// extracted by mini-css-extract-plugin
export default {"text":"verfiy_text__PMlOV","box":"verfiy_box__HsUUw","main":"verfiy_main__qCpGx","textField":"verfiy_textField__-WrWH","button":"verfiy_button__cOPj6"};